import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from './actionHelpers';

export const ILOQ_FETCH_REAL_ESTATES = 'ILOQ_FETCH_REAL_ESTATES';
export const ILOQ_FETCH_SEECURITY_ACCESSES_FOR_REAL_ESTATE = 'ILOQ_FETCH_SEECURITY_ACCESSES_FOR_REAL_ESTATE';

export const fetchIloqRealEstates = () => ({
    [RSAA]: {
        types: createRsaaTypes(ILOQ_FETCH_REAL_ESTATES),
        endpoint: '/api/iloq/realEstates',
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const fetchIloqSecurityAccessesForRealEstate = realEstateId => ({
    [RSAA]: {
        types: createRsaaTypes(ILOQ_FETCH_SEECURITY_ACCESSES_FOR_REAL_ESTATE),
        endpoint: `/api/iloq/realEstates/${realEstateId}/securityAccesses`,
        headers: createHeaders(false),
        method: 'GET'
    }
});
